/**
 * @generated SignedSource<<024c10bf8f13d18cd97600d6e4b1dbd2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventCompetitionsDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type EventCompetitionsDeleteMutation$data = {
  readonly removeEventCompetition: string;
};
export type EventCompetitionsDeleteMutation = {
  response: EventCompetitionsDeleteMutation$data;
  variables: EventCompetitionsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "removeEventCompetition",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCompetitionsDeleteMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "EventCompetitionsDeleteMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeEventCompetition",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4e01aec7be6b3be548e5f55f690bdf09",
    "id": null,
    "metadata": {},
    "name": "EventCompetitionsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EventCompetitionsDeleteMutation(\n  $id: ID!\n) {\n  removeEventCompetition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "ed7516ac25eb57dbd7e3a8dab249b82e";

export default node;
